define('lq/runtimeDispatcher',[
    'jquery',
    'lq',
    'when'
], function ($, lq, when) {
    'use strict';

    var getCsrfToken = function () {
        return $('input[name="__RequestVerificationToken"]', $('#__AjaxAntiForgeryForm')).val();
    };

    var RuntimeDispatcher = function (busyIndicator, actionVersion, masterPageVersion) {
        this.busyIndicator = busyIndicator;
        this.actionVersion = actionVersion;
        this.masterPageVersion = masterPageVersion;
        this.csrfToken = getCsrfToken();
    };
    
    RuntimeDispatcher.prototype.dispatch = function (url, data, success, options, error, doNotHandleUnauthorized) {
        url = lq.getTenantUrl(url);
        return this.dispatchToAbsoluteUrl(url, data, success, options, error, doNotHandleUnauthorized);
    };

    RuntimeDispatcher.prototype.dispatchToAbsoluteUrl = function (absoluteUrl, data, success, options, error, doNotHandleUnauthorized) {
        data = data || {};
        success = success || $.noop;
        error = error || $.noop;
        doNotHandleUnauthorized = doNotHandleUnauthorized || false;
        var self = this;
        var successFunc = function (result) {
            self.busyIndicator.hide();
            success(result);
        };
        var errorFunc = function (jqxhr) {
            // Automatically reload the page if we get a 401
            // when making a call to the url of the current tenant.
            // In all other cases (e.g. the annotations integrations)
            // the calling code should handle this.
            //
            // Note that this is not the best way to handle this
            // (the user will briefly see an error dialog), cause
            // we're using a mix of callbacks and promises
            if (jqxhr.status === 401 && absoluteUrl.indexOf(lq.getTenantUrl('')) === 0 && !doNotHandleUnauthorized) {
                window.location.reload();
            } else {
                try {
                    error();
                } finally {
                    self.busyIndicator.hide();
                }
            }
        };
        options = options || {};

        this.busyIndicator.show();
        return this.doDispatch(absoluteUrl, data, successFunc, errorFunc, options);
    };

    RuntimeDispatcher.prototype.backgroundDispatch = function (url, data, success, options, error) {
        url = lq.getTenantUrl(url);
        return this.doDispatch(url, data || {}, success || $.noop, error || $.noop, options || {});
    };

    RuntimeDispatcher.prototype.doDispatch = function (url, data, successFunc, errorFunc, options) {
        var headers = options.headers || {};

        headers.LicquidActionVersion = this.actionVersion;
        headers.LicquidMasterPageVersion = this.masterPageVersion;

        if (this.csrfToken)
            headers['__RequestVerificationToken'] = this.csrfToken;

        return when($.ajax($.extend(
            {
                url: url,
                type: 'POST',
                cache: false,
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                headers: headers,
                success: function (data, status, response) {
                    if (data.status === "VersionMismatch") {
                        window.location.reload();
                        return;
                    }
                    successFunc(data, status, response);
                },
                error: errorFunc
            },
            options)));
    };

    RuntimeDispatcher.prototype.getMessageFromResponse = function (jqxhr) {
        var response;
        try {
            response = JSON.parse(jqxhr.responseText);
        }
        catch (ignore) { }
        return response && response.message;
    };

    RuntimeDispatcher.prototype.refreshCsrfToken = function (callback) {
        var self = this;
        $.get(lq.getTenantUrl('LicquidAction/GetCsrfToken'), function (data) {
            self.csrfToken = $(data).val();
            callback();
        });
    };

    return RuntimeDispatcher;
});
